"use strict";
'use es6'; // Objects in these files are like ImmutableRecord defaults
// anything undefined should be overridden or else unit tests will fail
// anything null/defined can stay as such

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BizObjectivesMapDefault = exports.MerchandiseObjectDefault = exports.FeatureObjectDefault = exports.HubObjectDefault = void 0;
var HubObjectDefault = {
  merchandise: undefined,
  highlightedPaidMerch: [],
  highlightedFreeMerch: undefined,
  hubSpecificFeatures: [],
  merchPurchaseType: undefined
};
exports.HubObjectDefault = HubObjectDefault;
var FeatureObjectDefault = {
  limits: null,
  // Map of merch to limit string key
  isNew: false,
  comingSoon: false
}; // properties that should not be undefined

exports.FeatureObjectDefault = FeatureObjectDefault;
var MerchandiseObjectDefault = {
  chargeType: undefined,
  trackingName: undefined,
  parcels: undefined,
  quantityMultiplier: null,
  quantityUpgradeMerchandiseId: null,
  // this is redundant with additionalUnitMerchId -- should remove
  productName: null,
  billingNameKey: null,
  features: null,
  addons: null,
  services: null,
  activelySold: true,
  includedAdditionalUnits: null,
  maxAdditionalUnits: null,
  additionalUnitMerchId: null
};
exports.MerchandiseObjectDefault = MerchandiseObjectDefault;
var BizObjectivesMapDefault = {
  features: [],
  breakoutData: null // TODO: When we have breakout pages, stuff should go here
  // Assumption being that bizObjective <-> breakout page is 1:1
  // If this assumption changes in the future, we should separate breakouts
  // into their own object and map it as necessary

};
exports.BizObjectivesMapDefault = BizObjectivesMapDefault;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ObjectDefaults.js
// module id = 211
// module chunks = 5 6 7